import { useMemo } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependencies
import { useGetNodeUserAvatar } from 'features/users/hooks';
import type { VirtualChatMessageRow } from '../../../types';

type P = {
  row: VirtualChatMessageRow;
};

export const useChatMessageLayout = ({ row }: P) => {
  const getAvatarUrl = useGetNodeUserAvatar();
  const authorId = row.group.author?.id;

  return useMemo(() => {
    const messagesAlignment = row.direction === 'incoming' ? 'flex-start' : 'flex-end';
    const isIncomingWithAuthor = row.direction === 'incoming' && Boolean(authorId);
    const isLastInGroup = row.group.index === row.group.length - 1;
    const shouldShowAvatar = isIncomingWithAuthor && isLastInGroup;
    const shouldShowAvatarSpacer = isIncomingWithAuthor && !shouldShowAvatar;
    const outerAlignment = shouldShowAvatar ? 'flex-end' : messagesAlignment;

    return {
      messagesAlignment,
      outerAlignment,
      shouldShowAvatar,
      shouldShowAvatarSpacer,
      src: shouldShowAvatar && authorId ? getAvatarUrl({ userId: authorId }) : undefined,
    };
  }, [authorId, getAvatarUrl, row.direction, row.group.index, row.group.length]);
};
